import Model from './Model'
import RoundedRect from '../Rendering/RoundedRect'
import HoverMask from './HoverMask'
import RGBA from '../Fonts/RGBA'
import State from './State'
import game from '../Game/GameInstance'
import colorSchemeRepository from '../Images/ColorSchemeRepository'

let roundedRectRenderer = new RoundedRect();

export default class MiniViewport extends Model {

  constructor(width, height, data) {

    super(width, height, data);
    this.game = data.game;
    this.clearBeforePositioning = true;
    this.hoverMask = new HoverMask(this, true);

    this.state = new State();

  }

  draw(ctx) {

    if (!this.state.update({
      x : this.game.x,
      y : this.game.y,
      width : game.getWindowSize().width,
      height: game.getWindowSize().height,
      zoom : this.zoom
    })) {
      return;
    }


    if (!this.game.width) {
      return;
    }

    let scale = this.width / this.game.width;

    if (this.game.height * scale > this.height) {
      scale = this.height / this.game.height;
    }


    ctx.save();
    this.drawBackgroundShape(ctx);
    ctx.fillStyle = 'rgb(0,0,0,0.6)';
    ctx.fill();

    ctx.clip();


    this.drawRooms(ctx, scale);
    this.drawWindow(ctx, scale);

    ctx.restore();

    this.drawBackgroundShape(ctx);

    ctx.strokeStyle = colorSchemeRepository.get('foregroundText');
    ctx.lineWidth = this.scale(2);
    ctx.stroke();

    this.hoverMask.add('minimap', 0, 0, this.width, this.height)
      .repeat()
      .click((x,y) => {

        this.game.x = this.scale((x / scale) - (game.getWindowSize().width / 2));
        this.game.y = this.scale((y / scale) - (game.getWindowSize().height / 2));

      });

  }

  drawRooms(ctx, scale) {

    ctx.beginPath();
    ctx.fillStyle = colorSchemeRepository.get('roomBackground');

    this.game.rooms.forEach(room => {

      let x = room.x * scale;
      let y = room.y * scale;

      let w = room.width * scale;
      let h = room.height * scale;

      roundedRectRenderer.drawOn(ctx, this.scale(x),this.scale(y),this.scale(w),this.scale(h), this.scale(2));

    });
    ctx.fill();

  }

  drawWindow(ctx, scale) {


    let w = game.getWindowSize().width * scale;
    let h = game.getWindowSize().height * scale;
    let x = this.game.x * scale;
    let y = this.game.y * scale;

    ctx.beginPath();
    ctx.fillStyle = 'rgba(0,0,0,0.50)';
    ctx.rect(this.scale(-10), this.scale(-10), this.scale(this.width + 20), this.scale(this.height + 20));
    ctx.rect(this.coord(x),this.coord(y),this.scale(w),this.scale(h));
    ctx.fill('evenodd');

    ctx.strokeStyle = colorSchemeRepository.get('foregroundText');
    ctx.lineWidth = this.scale(2);

    ctx.stroke();

  }

  drawBackgroundShape(ctx) {

    let radius = 10;
    // @todo : add margin

    ctx.beginPath();

    ctx.moveTo(this.scale(radius), this.scale(0));

    // top
    ctx.lineTo(this.scale(this.width - radius), this.scale(0));

    // top right
    ctx.quadraticCurveTo(this.scale(this.width), 0, this.scale(this.width), this.scale(radius));

    // right
    ctx.lineTo(this.scale(this.width), this.scale(this.height - radius));

    // bottom right
    ctx.quadraticCurveTo(this.scale(this.width), this.scale(this.height), this.scale(this.width - radius), this.scale(this.height));

    // bottom
    ctx.lineTo(this.scale(radius), this.scale(this.height));

    // bottom left
    ctx.quadraticCurveTo(0, this.scale(this.height), 0, this.scale(this.height - radius));

    // left
    ctx.lineTo(0, this.scale(radius));

    // top left
    ctx.quadraticCurveTo(0,0, this.scale(radius), 0);
    ctx.closePath();

  }

}
